import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth, authErrorMessage } from "../context/AuthContext";
import { useI18n } from "../i18n";
import { withLang } from "../i18n/paths";
import Pic from "./pics";

// Shown instead of the site to email sign-ups until they click the link in
// the verification email. It checks by itself every few seconds (and when
// they come back to the tab), so usually nothing needs tapping.
export default function VerifyEmail() {
  const { t, tx, lang } = useI18n();
  const { user, sendVerification, checkVerification, logout } = useAuth();
  const [busy, setBusy] = useState(null);
  const [note, setNote] = useState("");

  useEffect(() => {
    const check = () => checkVerification().catch(() => {});
    const id = setInterval(check, 4000);
    window.addEventListener("focus", check);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", check);
    };
  }, [checkVerification]);

  const run = async (what, fn) => {
    setBusy(what);
    setNote("");
    try {
      await fn();
    } catch (e) {
      setNote(authErrorMessage(e));
    } finally {
      setBusy(null);
    }
  };

  const resend = () =>
    run("send", async () => {
      await sendVerification();
      setNote(t("Sent! Check {email} (and your spam folder).", { email: user.email }));
    });
  const verified = () =>
    run("check", async () => {
      if (!(await checkVerification())) setNote(t("Not verified yet. Tap the link in the email first, then try again."));
    });

  return (
    <div className="verify-email panel">
      <div className="room-message-emoji">
        <Pic name="mail" />
      </div>
      <h2>{t("Check your email")}</h2>
      <p>{tx("We sent a link to <b>{email}</b>. Tap it to verify your email and finish making your account.", { email: user.email })}</p>
      <div className="verify-actions">
        <button className="btn btn-primary btn-lg" onClick={verified} disabled={!!busy}>
          {busy === "check" ? t("Checking…") : t("I've verified it")}
        </button>
        <button className="btn btn-ghost" onClick={resend} disabled={!!busy}>
          {busy === "send" ? t("Sending…") : t("Send the email again")}
        </button>
      </div>
      {note && <p className="verify-note">{note}</p>}
      <p className="muted small">
        {tx(
          "Can't find it? Check your spam folder. Wrong email or just want to play? <signout>Sign out</signout> and play as a guest.",
          {},
          {
            signout: (c, k) => (
              <button key={k} className="link" onClick={logout}>
                {c}
              </button>
            ),
          }
        )}
      </p>
      <p className="muted small">
        <Link to={withLang(lang, "/privacy")}>{t("Privacy")}</Link> · <Link to={withLang(lang, "/terms")}>{t("Terms")}</Link>
      </p>
    </div>
  );
}
